import { FlexBox } from '@airship-platform/jam-web/components';
import Typography from '@mui/material/Typography';

const DataCollectionCompleted: React.FC = () => (
  <FlexBox flexDirection={'column'} gap={2}>
    <Typography variant="body1">
      Your home comfort advisor will let you know if you are eligible for any
      tax incentives when they are building your proposal.
    </Typography>
    <Typography variant="body1">Feel free to close this window.</Typography>
  </FlexBox>
);

export default DataCollectionCompleted;
